module.exports = __webpack_public_path__ + "img/slide_notice_open.75619906.svg";